import { Listeners } from './utils.js';

class CosShoplook extends HTMLElement {
  constructor() {
    super();
    this.listeners = new Listeners();
    this.isShowing = this.classList.contains('show');
  }

  connectedCallback() {
    this.initShoplook();
  }

  disconnectedCallback() {
    this.listeners.removeAll();
  }

  initShoplook() {
    const trigger = this.querySelector('[toggle-shoplook]');
    if (!trigger) return;

    this.listeners.add(trigger, 'click', (e) => {
      e.preventDefault();
      this.toggleShoplook();
    });
  }

  toggleShoplook() {
    (this.isShowing) ? this.hideShoplook() : this.showShoplook();
  }

  showShoplook() {
    this.classList.add('show');
    this.isShowing = true;
  }

  hideShoplook() {
    this.classList.remove('show');
    this.isShowing = false;
  }
}
customElements.define('cos-shoplook', CosShoplook);